import { FullPost } from 'model';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../App.js';
import { LoginState } from '../../state/loginSlice.js';
import { isPostPromoted } from '../../util/isPostPromoted.js';
import { PromotePost } from '../PromotePost.js';
import { IconCheckCircle } from '../QuirkIcons/index.js';
import styles from './PromotedView.module.css';
import { useLicenseFeature } from '../../hooks/useLiscenseFeature.js';
import { useGetPublicInformationQuery } from '../../api/SiteSettingsAPI.js';
export interface PromotedViewProps {
	post?: FullPost;
	children: ReactNode;
	detail?: boolean;
}

export function PromotedView({ post, children, detail }: PromotedViewProps) {
	const { data: info } = useGetPublicInformationQuery();
	const { isPromoted, willBePromoted } = isPostPromoted({
		startDate: post?.promotionStartDate || '',
		endDate: post?.promotionEndDate || ''
	});

	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const userid = state.user._id;
	const isOwnPost = userid === post?.author;

	// Don't show if feature not enabled
	const promotionFeatureEnabled = useLicenseFeature('payments') && info?.supportsPayments;
	if (!promotionFeatureEnabled) {
		return <>{children}</>;
	}
	return (
		<>
			{isPromoted ? (
				<>
					<div data-testid="PostPromotedIndicator" className={styles.promotedLabel}>
						<span>
							<IconCheckCircle size={15} />
						</span>
						<span>Promoted</span>
					</div>
					<div className="space10" />
					<div>{children}</div>
				</>
			) : (
				<>
					{isOwnPost && !willBePromoted && detail ? (
						<>
							{children}
							<div className="space20" />
							<PromotePost post={post} feed />
						</>
					) : (
						<>{children}</>
					)}
				</>
			)}
		</>
	);
}
